import React from 'react';
import Image from '../../../basic/image'
import styled from "styled-components";
import Ассортимент from '../../../static/Большой_ассортимент.png'
import Регионы from '../../../static/Работа_с_регионами.png'
import Доставка from '../../../static/Доставка.png'
import * as media from "../../../media";
import {compose, lifecycle} from "recompose";
import TranslateText from 'src/text/modal';
import CurrentLanguageContext from 'src/context/currentLanguageContext';


const TranslateWrapStyled = styled.div`
  display: inline-block;
  width: 200px;
  text-align: left;
  vertical-align: top;
  ${media.smallerThan(1361)` width: 270px;`}
  ${media.smallerThan(1090)` width: calc(50% - 20px);`}
  ${media.biggerThan(1361)` width: calc(33% - 20px);`}
`

const CardDiv = styled.div`
  padding-top: 20px;
  padding-bottom: 20px;
  width: 100%;
  text-align: left;
`

function Card({text, image}) {
  return (
    <CardDiv>
      <Image
        src={image}
        width={'100%'}
        containerStyle={{
          display: 'inline-block',
          verticalAlign: 'middle',
          width: '35%',
        }}
      />
      <div
        className={'hyphenate'}
        style={{
          marginTop: 10,
          display: 'inline-block',
          verticalAlign: 'middle',
          width: '65%',
          textTransform: 'uppercase',
          color: '#173DB0',
        }}
        dangerouslySetInnerHTML={{'__html': text}}
      />
    </CardDiv>
  )
}

function desktop() {
  return (
    <CurrentLanguageContext.Consumer>
      {currentLanguage => {
        return (

          <div
            style={{
              textAlign: 'center',
              width: '80%',
              margin: '0 auto',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                flexWrap: 'wrap',
                alignItems: 'center',
                marginLeft: -17,
              }}
            >
              <TranslateWrapStyled>
                <TranslateText
                  id="partners__large_assortment"
                  useHtml
                  controls={["bold"]}
                  render={html => {
                    return (
                      <Card
                        text={html}
                        image={Ассортимент}
                      />
                    );
                  }}
                />
              </TranslateWrapStyled>
              {currentLanguage === 'ru' &&
                <TranslateWrapStyled>
                  <TranslateText
                    id="partners__regions"
                    useHtml
                    controls={["bold"]}
                    render={html => {
                      return (
                        <Card
                          text={html}
                          image={Регионы}
                        />
                      );
                    }}
                  />
                </TranslateWrapStyled>
              }
              <TranslateWrapStyled>
                <TranslateText
                  id="partners__delivery"
                  controls={["bold"]}
                  useHtml
                  render={html => {
                    return (
                      <Card
                        text={html}
                        image={Доставка}
                      />
                    );
                  }}
                />
              </TranslateWrapStyled>
            </div>
          </div>
        );
      }}
    </CurrentLanguageContext.Consumer>
  )
}

const enhance = compose(
  lifecycle({
    componentDidUpdate() {
      setTimeout(() => {
        window.Hyphenator.run();
      }, 0)
    }
  }),
)

export default enhance(desktop)



// WEBPACK FOOTER //
// ./src/finwhale/common/opt-princip/Desktop.js